import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './FormInput.styled';
import { useFormControl } from '../FormControl/FormControl.context';

/**
 * `FormInput` is a building block for creating an input.
 * It uses state from `FormControl`, and has built-in support for displaying an error message.
 */
const FormInput = React.forwardRef((props, ref) => {
  const formContext = useFormControl();

  const { onChange: inputOnChange } = props;
  const { onChange: formikOnChange } = formContext.inputProps;

  const handleOnChange = useCallback((event) => {
    if (inputOnChange) {
      inputOnChange(event);
    }

    // formik onChange must be called after our custom onChange
    // so that we can modify the target value before formik updates
    if (formikOnChange) {
      formikOnChange(event);
    }
  });

  return (
    <>
      <Styled.Input
        {...props}
        {...formContext.inputProps}
        onChange={handleOnChange}
        ref={ref}
        hasError={!!formContext.errorMessage}
        isFocused={formContext.isFocused}
        isEmpty={formContext.isEmpty}
      />
      {typeof formContext?.errorMessage === 'string' &&
        !!formContext.errorMessage && (
          <Styled.Error>{formContext.errorMessage}</Styled.Error>
        )}
    </>
  );
});

FormInput.propTypes = {
  /**
   * optional function for custom onChange behavior of the input
   */
  onChange: PropTypes.func
};

FormInput.defaultProps = {
  onChange: undefined
};

export default FormInput;
